import { render, staticRenderFns } from "./PbcCta.vue?vue&type=template&id=b805dc4e&scoped=true&"
import script from "./PbcCta.vue?vue&type=script&lang=js&"
export * from "./PbcCta.vue?vue&type=script&lang=js&"
import style0 from "./PbcCta.vue?vue&type=style&index=0&id=b805dc4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b805dc4e",
  null
  
)

export default component.exports